/**
 * Styles for the Managed AI funding chooser and balance view.
 *
 * Rules: MS1-3 (provider neutrality), MS1-1.
 */

import type { CSSProperties } from 'react';

export const pageStyles = {
  container: {
    maxWidth: '880px',
    margin: '0 auto',
    padding: '1rem 0',
  } as CSSProperties,
  header: {
    marginBottom: '2rem',
  } as CSSProperties,
  section: {
    padding: '1.5rem',
    border: '1px solid var(--line, #372d46)',
    borderRadius: '0.65rem',
    background: 'var(--surface, #1c1726)',
    marginBottom: '1.75rem',
  } as CSSProperties,
  sectionTitle: {
    marginTop: 0,
    marginBottom: '0.5rem',
    fontSize: '1.25rem',
    color: '#f5efe6',
  } as CSSProperties,
  sectionDescription: {
    color: 'var(--muted, #a99db5)',
    marginTop: 0,
    marginBottom: '1.25rem',
    fontSize: '0.95rem',
    lineHeight: 1.5,
  } as CSSProperties,
  optionCard: {
    padding: '1.25rem',
    border: '1px solid var(--line, #372d46)',
    borderRadius: '0.5rem',
    background: 'var(--surface-raised, #251e32)',
    marginBottom: '0.85rem',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'flex-start',
    gap: '0.85rem',
  } as CSSProperties,
  optionCardSelected: {
    borderColor: 'var(--accent, #3fb4a8)',
  } as CSSProperties,
  optionCardDisabled: {
    opacity: 0.6,
    cursor: 'not-allowed',
  } as CSSProperties,
  radio: {
    marginTop: '0.25rem',
    width: 'auto',
    flex: 'none',
    cursor: 'pointer',
  } as CSSProperties,
  optionContent: {
    flex: 1,
  } as CSSProperties,
  optionTitle: {
    fontSize: '1.05rem',
    fontWeight: 650,
    color: '#f5efe6',
    margin: '0 0 0.35rem 0',
  } as CSSProperties,
  optionDescription: {
    fontSize: '0.9rem',
    color: 'var(--muted, #a99db5)',
    margin: 0,
    lineHeight: 1.5,
  } as CSSProperties,
  balanceGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
    gap: '1rem',
    marginTop: '1.25rem',
    marginBottom: '1.5rem',
  } as CSSProperties,
  metricCard: {
    padding: '1.25rem',
    border: '1px solid var(--line, #372d46)',
    borderRadius: '0.55rem',
    background: 'var(--surface-raised, #251e32)',
  } as CSSProperties,
  metricLabel: {
    fontSize: '0.8rem',
    fontWeight: 700,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color: 'var(--muted, #a99db5)',
    marginBottom: '0.35rem',
  } as CSSProperties,
  metricValue: {
    fontSize: '1.75rem',
    fontWeight: 700,
    color: '#f5efe6',
    fontVariantNumeric: 'tabular-nums',
  } as CSSProperties,
  noticeBox: {
    padding: '0.9rem 1.1rem',
    borderLeft: '3px solid var(--warning, #f5ca7b)',
    background: '#201a10',
    borderRadius: '0.35rem',
    marginTop: '0.85rem',
    marginBottom: '1rem',
    color: '#f5ca7b',
    fontSize: '0.9rem',
    lineHeight: 1.5,
  } as CSSProperties,
  saveButton: {
    marginTop: '1rem',
  } as CSSProperties,
  feedbackSuccess: {
    color: 'var(--accent, #3fb4a8)',
    marginTop: '0.75rem',
    fontSize: '0.9rem',
  } as CSSProperties,
  feedbackError: {
    color: 'var(--danger, #ff9c98)',
    marginTop: '0.75rem',
    fontSize: '0.9rem',
  } as CSSProperties,
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '1rem',
  } as CSSProperties,
  th: {
    textAlign: 'left',
    padding: '0.65rem',
    borderBottom: '1px solid var(--line, #372d46)',
    color: '#cfc4d6',
    fontSize: '0.8rem',
    letterSpacing: '0.04em',
    textTransform: 'uppercase',
  } as CSSProperties,
  td: {
    textAlign: 'left',
    padding: '0.65rem',
    borderBottom: '1px solid var(--line, #372d46)',
    fontSize: '0.9rem',
  } as CSSProperties,
  emptyActivity: {
    color: 'var(--muted, #a99db5)',
    fontStyle: 'italic',
    margin: '1rem 0',
  } as CSSProperties,
};
